import React, { type FC } from 'react';

import { Xmark } from '@gravity-ui/icons';
import { Button, Icon, Modal } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/PrivateApps';

import styles from './QuickAppsModal.module.scss';

interface Props {
    open?: boolean;
    onClose: () => void;
    onAccept: () => void;
    title: string;
    text: React.ReactNode;
    loading?: boolean;
}

const t = i18n(keyset);

export const QuickAppsModal: FC<Props> = ({ open, onClose, onAccept, title, text, loading }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <div className={styles.quickAppsModal__container}>
                <header className={styles.quickAppsModal__header}>
                    <h4 className={styles.quickAppsModal__title}>{title}</h4>
                    <Button className={styles.quickAppsModal__closeButton} onClick={onClose} view="flat" size="l">
                        <Icon size={20} data={Xmark} />
                    </Button>
                </header>
                <div className={styles.quickAppsModal__text}>{text}</div>
                <div className={styles.quickAppsModal__buttonsContainer}>
                    <Button className={styles.quickAppsModal__button} onClick={onClose} size="l">
                        {t('cancel')}
                    </Button>
                    <Button
                        className={styles.quickAppsModal__button}
                        onClick={onAccept}
                        loading={loading}
                        size="l"
                        view="action"
                    >
                        {t('accept')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
